import { getFav, addFav, removeFav } from "../../utils/api";
import { START_LOADING, END_LOADING } from "./loading_actions";
import { SET_PORTAL_API } from "./portal_actions";
import { TITLE_ERROR } from "../../utils/constants";

// export const GET_FAV_REQUEST = 'GET_FAV_REQUEST';
export const GET_FAV_REQUEST_SUCCESS = 'GET_FAV_REQUEST_SUCCESS';
export const GET_FAV_REQUEST_FAILED = 'GET_FAV_REQUEST_FAILED';
// export const ADD_FAV_REQUEST = 'ADD_FAV_REQUEST';
export const ADD_FAV_REQUEST_SUCCESS = 'ADD_FAV_REQUEST_SUCCESS';
export const ADD_FAV_REQUEST_FAILED = 'ADD_FAV_REQUEST_FAILED';
// export const REMOVE_FAV_REQUEST = 'REMOVE_FAV_REQUEST';
export const REMOVE_FAV_REQUEST_SUCCESS = 'REMOVE_FAV_REQUEST_SUCCESS';
export const REMOVE_FAV_REQUEST_FAILED = 'REMOVE_FAV_REQUEST_FAILED';
export const CLEAR_FAV = 'CLEAR_FAV';


export const getFavThunk = (accessToken, refreshToken) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING });
    getFav(accessToken, refreshToken)
      .then(data => {
        dispatch({
          type: GET_FAV_REQUEST_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        dispatch({ type: GET_FAV_REQUEST_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const addFavThunk = (accessToken, refreshToken, id) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING });
    addFav(accessToken, refreshToken, id)
      .then(data => {
        dispatch({
          type: ADD_FAV_REQUEST_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        dispatch({ type: ADD_FAV_REQUEST_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}

export const removeFavThunk = (accessToken, refreshToken, id) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING });
    removeFav(accessToken, refreshToken, id)
      .then(data => {
        dispatch({
          type: REMOVE_FAV_REQUEST_SUCCESS,
          payload: data
        });
      })
      .catch(error => {
        dispatch({ type: REMOVE_FAV_REQUEST_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
